export interface UIConfig {
    logo: string;
    sidebarFooterLogo: string[];
    vars: Record<string, string>;
    'font-family': string;
}

export const uiConfig: UIConfig = {
    logo: 'images/eng-logo.jpg',
    sidebarFooterLogo: [],
    vars: {},
    'font-family': 'open-sans'
};
